import {Component, OnInit, ViewChild, ElementRef} from '@angular/core';
import {GroupModel} from '../../../models/school/group.model';
import {ActivatedRoute, Params} from '@angular/router';
import {SchoolGroupsService} from '../../../services/school/school-groups.service';
import {StudentModel} from '../../../models/authentication/student.model';
import {StudentFilterModel} from '../../../models/filters/student-filter.model';
import {SkillGroupBaseModel} from '../../../models/edu-admin/skillGroupBase.model';
import {SkillGroupStructureModel} from '../../../models/student/skillGroupStatusModel';
import {forkJoin} from 'rxjs';
import {GroupDashSkillsOverviewComponent} from './group-dash-skills-overview/group-dash-skills-overview.component';
import {PlacementTestModel} from '../../../models/edu-admin/placement-test.model';
import {PlacementTestGroupAttempt} from '../../../models/student/placement-test-attempt.model';
import {AppEventsService} from '../../../services/events/app-events.service';

@Component({
  selector: 'app-group-dashboard',
  templateUrl: './group-dashboard.component.html',
  styleUrls: ['./group-dashboard.component.css']
})
export class GroupDashboardComponent implements OnInit {

  group: GroupModel;

  skillStatus: SkillGroupStructureModel;
  placementStatus: SkillGroupStructureModel;
  skillGroupsObjective: SkillGroupBaseModel[] = [];
  skillGroupsPlacement: SkillGroupBaseModel[] = [];

  placementTest: PlacementTestModel;
  attempts: PlacementTestGroupAttempt[];

  students: StudentModel[] = [];

  scrollOffset = 0;

  @ViewChild('scrollContainer', { static: true }) scrollContainer: ElementRef;

  constructor(private route: ActivatedRoute,
              private schoolGroupSv: SchoolGroupsService,
              private appEventSv: AppEventsService) { }

  ngOnInit() {
    this.route.parent.params.subscribe((params: Params) => {

      const groupId = params.groupId;

      this.schoolGroupSv.fetchGroup(groupId).subscribe((g) => {
        this.group = g;
      });

      const studentFilter = new StudentFilterModel();
      studentFilter.limit = 100;
      studentFilter.includeTeacherStudents = 1;

      const fetchStudents = this.schoolGroupSv.fetchStudentForGroup(groupId);
      const fetchGroupSkills = this.schoolGroupSv.fetchGroupSkills(groupId);
      const fetchPlacementTest = this.schoolGroupSv.fetchPlacementTestForGroup(groupId);


      forkJoin([
        fetchStudents,
        fetchGroupSkills,
        fetchPlacementTest
      ]).subscribe((data) => {

        this.students = data[0];
        this.skillGroupsObjective = data[1].skillGroups.sort((s1, s2) => s1.order - s2.order);

        this.skillStatus =  SkillGroupStructureModel.setupWithSkillStatus(this.students, this.skillGroupsObjective, data[1].skills);

        this.placementTest = data[2].placementTest;
        const skillGroupsInPlacement = this.placementTest.getSkillGroupIdsInUse();

        this.attempts = data[2].attempts;
        this.skillGroupsPlacement = this.skillGroupsObjective.filter((s) => skillGroupsInPlacement.includes(s._id)).sort((s1, s2) => s1.order - s2.order);
        this.placementStatus = SkillGroupStructureModel.setupWithPlacementTestAttempt(this.students, this.skillGroupsPlacement, data[2].attempts);

      });


    });

  }

  getNumStudents() {

    if (this.group) {
      return this.group.studentIds.length;
    }

  }

  scrollEvent(e) {

    if (this.scrollContainer && this.scrollContainer.nativeElement) {
      // Use the service to handle scroll event and container management
      this.appEventSv.handleScroll(this.scrollContainer.nativeElement, 'group-dashboard');

    } else {
      console.warn('Scroll container is null or undefined!');
    }
  }




}
